import React from 'react';
import './NotificationToast.css';

function NotificationToast({ notifications, onDismiss, onSelect }) {
    return (
        <div className="toast-container">
            {notifications.map(notif => (
                <div
                    key={notif.id}
                    className="toast"
                    onClick={() => {
                        onSelect(notif);
                        onDismiss(notif.id);
                    }}
                >
                    <div className="toast-avatar">
                        {notif.avatar
                            ? <img src={notif.avatar} alt="avatar" />
                            : notif.senderName?.charAt(0).toUpperCase()
                        }
                    </div>
                    <div className="toast-content">
                        <div className="toast-title">{notif.senderName}</div>
                        <div className="toast-message">{notif.preview}</div>
                    </div>
                    <button
                        className="toast-close"
                        onClick={(e) => { e.stopPropagation(); onDismiss(notif.id); }}
                    >
                        ✕
                    </button>
                </div>
            ))}
        </div>
    );
}

export default NotificationToast;